// Module
var code = "<ns-bind-html html=\"{{text}}\"></ns-bind-html> ";
// Exports
module.exports = code;